{
  "_comment": "設備目錄的 zh-Hant 名稱，由 component/protocol model/ui.yaml（8dfff68）抽出（web/scripts/kinio_ui_labels.py）。attrs / commands：稽核「下了命令」寫名稱用（SPEC #vms-web-817 動作對照表 device.command：op = set / get 查 attrs、invoke 查 commands）。events：事件顯示名稱（SPEC #events-26：正本 = App 畫面，VMS 照抄；labels 依欄位值換名字；alert_class 取自 model/clusters.yaml，警報判斷用，SPEC #events-127；feed_only = retention feed_only，不進全文索引、事件頁串流也不插，SPEC #events-88）。其他語系照 key 查 kinio_ui_strings.json（attrs / commands 用 label_id，事件用 event.<key>、event.<key>.<欄位>.<值>）。protocol 改名稱時重抽",
  "attrs": {
    "basic_information.node_label": "名稱",
    "basic_information.product_name": "型號",
    "basic_information.software_version_string": "韌體版本",
    "basic_information.hardware_version_string": "硬體版本",
    "basic_information.serial_number": "序號",
    "kinio_system.online": "連線狀態",
    "kinio_system.ip": "IP 位址",
    "kinio_system.ip6": "IPv6 位址",
    "kinio_system.wifi_ssid": "Wi-Fi 網路",
    "kinio_system.wifi_signal_percent": "訊號強度",
    "kinio_system.device_temperature": "機體溫度",
    "kinio_system.timezone": "時區",
    "kinio_system.device_time": "設備時間",
    "kinio_system.hdd_status": "硬碟狀態",
    "kinio_system.hdd_free_gb": "可用容量",
    "kinio_system.fan_status": "風扇",
    "kinio_system.network_status": "網路狀態",
    "kinio_system.net_mode": "網路模式",
    "kinio_system.channel_online_summary": "通道摘要",
    "kinio_system.report_status_freq": "回報頻率",
    "kinio_system.wifi_regulatory": "Wi-Fi 法規",
    "power_source.bat_percent_remaining": "電量",
    "power_source.bat_charge_state": "充電狀態",
    "power_source.wired_present": "外接電源",
    "kinio_firmware.channel": "更新通道",
    "kinio_firmware.components": "部件版本",
    "kinio_firmware.security_floor": "安全下限",
    "kinio_debug.log_upload": "debug log 上傳",
    "kinio_debug.log_level": "debug log 門檻",
    "kinio_debug.log_upload_until": "debug log 到期",
    "kinio_debug.shell": "遠端 shell",
    "kinio_debug.root_login_until": "root 登入到期",
    "kinio_debug.remote_shell_until": "遠端 shell 到期",
    "kinio_power.power_mode": "電源模式",
    "kinio_power.keepalive_interval_seconds": "連線保活間隔",
    "kinio_power.low_battery_threshold": "低電量提醒",
    "kinio_power.standby_state": "待機狀態",
    "kinio_power.battery_lock": "低電量保護",
    "kinio_power.check_in_interval_seconds": "同步間隔",
    "kinio_power.next_check_in_at": "下次同步",
    "kinio_channel.index": "通道",
    "kinio_channel.state": "狀態",
    "kinio_channel.protocol": "連線協定",
    "kinio_channel.custom_slot": "自訂協定編號",
    "kinio_channel.host": "位址",
    "kinio_channel.port": "連接埠",
    "kinio_channel.user": "帳號",
    "kinio_channel.main_url": "主串流路徑",
    "kinio_channel.sub_url": "次串流路徑",
    "kinio_channel.transport": "傳輸方式",
    "kinio_channel.covert": "隱藏此通道",
    "kinio_channel.codec": "編碼",
    "kinio_channel.fps": "幀率",
    "kinio_channel.bitrate": "位元率",
    "kinio_channel.audio": "音訊",
    "kinio_channel.error": "錯誤",
    "kinio_onvif.discovered": "探索到的攝影機",
    "kinio_onvif.templates": "自訂協定樣板",
    "kinio_video_signal.video_loss_enabled": "影像訊號中斷時通知",
    "kinio_video_signal.signal_present": "訊號",
    "kinio_motion.enabled": "移動偵測",
    "kinio_motion.sensitivity": "靈敏度",
    "kinio_motion.zone_enabled": "限定偵測區域",
    "kinio_motion.zones": "偵測區域",
    "kinio_motion.zone_grid": "偵測區域",
    "kinio_motion.schedule": "生效時段",
    "kinio_motion.alarm_interval_seconds": "通知間隔",
    "kinio_motion.human_filter": "只在偵測到人時通知",
    "kinio_motion.object_outline": "畫面標示偵測框",
    "kinio_motion.pir_sensitivity": "PIR 靈敏度",
    "kinio_motion.pir_mode": "PIR 模式",
    "kinio_motion.pir1_enabled": "移動感測器 1",
    "kinio_motion.pir2_enabled": "移動感測器 2",
    "kinio_motion.pir3_enabled": "移動感測器 3",
    "kinio_motion.timer_enabled": "定時偵測",
    "occupancy_sensing.occupancy": "目前有人",
    "kinio_object_recognition.enabled": "AI 物件辨識",
    "kinio_object_recognition.confidence_threshold": "信心門檻",
    "kinio_sound_detection.enabled": "聲音偵測",
    "kinio_sound_detection.level": "觸發音量",
    "kinio_sound_detection.current_level": "目前音量",
    "kinio_sound_recognition.enabled": "聲音辨識",
    "kinio_tamper.enabled": "遮擋偵測",
    "kinio_analytics.enabled": "進階分析",
    "kinio_analytics.scene": "場景",
    "kinio_analytics.schedule": "生效時段",
    "kinio_analytics.line_crossing": "跨線偵測",
    "kinio_analytics.intrusion": "區域入侵",
    "kinio_analytics.object_left_taken": "物品遺留與移除",
    "kinio_analytics.pedestrian_vehicle": "人車偵測",
    "kinio_analytics.face_detection": "人臉偵測",
    "kinio_analytics.cross_counting": "進出計數",
    "kinio_analytics.heatmap": "熱點圖",
    "kinio_analytics.actions": "觸發動作",
    "kinio_analytics.last_event": "最近一次觸發",
    "kinio_recording.quality": "錄影畫質",
    "kinio_recording.stream_mode": "錄影串流",
    "kinio_recording.recording": "錄影中",
    "kinio_recording.rec_health": "每路錄影健康",
    "kinio_recording.cloud_applied": "雲端錄影套用狀態",
    "kinio_recording.schedule": "錄影排程",
    "kinio_recording.normal_schedule": "一般錄影時段",
    "kinio_recording.detection_schedule": "偵測錄影時段",
    "kinio_recording.event_mask": "觸發錄影的事件",
    "kinio_recording.pre_record_seconds": "事前錄影",
    "kinio_recording.manual_length_seconds": "手動錄影長度",
    "kinio_recording.pack_time_minutes": "分段長度",
    "kinio_recording.retention_days": "保留天數",
    "kinio_lens.record_secondary": "副鏡頭也錄影",
    "kinio_lens.lenses": "鏡頭",
    "kinio_lens.max_live_views": "同時觀看鏡頭數",
    "kinio_lens.shared_fps": "共用取像幀率",
    "kinio_lens.secondary_state": "副鏡頭錄影狀態",
    "kinio_recording.sd_enabled": "錄到記憶卡",
    "kinio_recording.sd_mode": "記憶卡錄影方式",
    "kinio_recording.quality_tier": "錄影畫質",
    "kinio_recording.spool": "補上傳",
    "kinio_streaming.supported_codecs": "支援編碼",
    "kinio_storage.sd_present": "記憶卡",
    "kinio_storage.sd_status": "記憶卡狀態",
    "kinio_storage.sd_format_type": "儲存方式",
    "kinio_storage.sd_format_reason": "需要格式化的原因",
    "kinio_storage.sd_capacity": "記憶卡容量",
    "kinio_storage.sd_vendor_area_bytes": "舊系統錄影區",
    "kinio_storage.disks": "硬碟",
    "kinio_storage.total_bytes": "總容量",
    "kinio_storage.free_bytes": "可用容量",
    "kinio_storage.overwrite": "空間不足時",
    "kinio_storage.reserve_gb": "保留空間",
    "kinio_storage.record_kbps": "寫入速率",
    "kinio_storage.smart": "硬碟健康",
    "kinio_storage.smart_auto_test": "每週自動健檢",
    "kinio_storage.quota_bytes": "錄影空間上限",
    "kinio_mycam.state": "狀態",
    "kinio_mycam.pause_reason": "暫停原因",
    "kinio_mycam.thermal": "溫度",
    "kinio_mycam.purpose": "用途",
    "kinio_mycam.lens": "鏡頭",
    "kinio_mycam.lenses": "可用鏡頭",
    "kinio_mycam.screen": "螢幕",
    "kinio_mycam.audio_detect": "聲音偵測",
    "kinio_mycam.audio_record": "錄音",
    "kinio_mycam.home_mode": "主人在家時暫停",
    "kinio_mycam.recorder": "錄影主機",
    "kinio_image.flip": "上下翻轉",
    "kinio_image.mirror": "左右鏡像",
    "kinio_image.watermark": "時間浮水印",
    "kinio_image.ai_overlay": "畫面標示偵測框",
    "kinio_image.privacy_mode": "隱私",
    "kinio_image.sleep_mode": "休眠",
    "kinio_image.privacy_mask_enabled": "隱私遮罩開關",
    "kinio_image.privacy_masks": "隱私遮罩",
    "kinio_image.flicker_hz": "防閃爍",
    "kinio_video.main_resolution": "主串流解析度",
    "kinio_video.main_kbps": "主串流碼率",
    "kinio_video.main_fps": "主串流幀率",
    "kinio_video.main_gop": "主串流關鍵幀間隔",
    "kinio_video.sub_resolution": "次串流解析度",
    "kinio_video.sub_kbps": "次串流碼率",
    "kinio_video.sub_fps": "次串流幀率",
    "kinio_video.sub_gop": "次串流關鍵幀間隔",
    "kinio_video.sensor_fps": "感測器幀率",
    "kinio_video.main_codec": "主串流編碼",
    "kinio_node.wifi_source": "目前使用",
    "kinio_node.user_wifi_ssid": "使用者 Wi-Fi",
    "kinio_node.site_name": "場域設定",
    "kinio_node.site_ssids": "場域 Wi-Fi",
    "kinio_node.ttl_enabled": "UART（TTL）橋接",
    "kinio_node.ttl_baud": "UART（TTL）速率",
    "kinio_node.ttl_token_set": "UART（TTL）密鑰已設定",
    "kinio_node.bound": "已綁定",
    "kinio_node.ttl_dut": "UART（TTL）接著的設備",
    "kinio_node.ttl_rx_at": "UART（TTL）最後有輸出",
    "kinio_station.info": "工位資訊",
    "kinio_station.resources": "工位資源",
    "kinio_station.activity": "工位活動",
    "kinio_station.leases": "工位租約",
    "kinio_station.ui_home": "本機首頁",
    "kinio_station.gateway_enabled": "讓 PoE 設備連上網路",
    "kinio_station.gateway_status": "出網狀態",
    "kinio_station.poe_ports": "PoE 孔",
    "kinio_station.poe_budget": "PoE 用電",
    "kinio_local_services.onvif_enabled": "ONVIF",
    "kinio_local_services.rtsp_enabled": "RTSP",
    "kinio_local_services.web_enabled": "本機網頁管理",
    "kinio_local_services.onvif_profiles": "ONVIF Profile",
    "kinio_local_services.credential_set": "已設定管理密碼",
    "kinio_camera_light.night_mode": "夜視",
    "kinio_camera_light.status_light": "狀態指示燈",
    "kinio_camera_light.warning_indicator": "警示指示燈",
    "kinio_camera_light.night_enter_lux": "切換到夜間的照度",
    "kinio_camera_light.night_exit_lux": "回到白天的照度",
    "kinio_camera_light.night_image": "夜間畫面",
    "kinio_floodlight.light_warn": "偵測到動靜時亮燈",
    "kinio_floodlight.mode": "燈光方式",
    "kinio_floodlight.trigger_condition": "亮燈時段",
    "kinio_floodlight.lux_threshold": "判斷天黑",
    "kinio_floodlight.light_on_duration_seconds": "亮燈多久",
    "kinio_floodlight.high_brightness": "亮燈亮度",
    "kinio_floodlight.low_brightness": "夜視常亮亮度",
    "kinio_floodlight.high_color_temp": "觸發色溫",
    "kinio_floodlight.low_color_temp": "常亮色溫",
    "kinio_floodlight.strobe_frequency": "閃爍速度",
    "kinio_floodlight.color_image_ctrl": "亮燈時改彩色畫面",
    "kinio_floodlight.red_blue_enabled": "紅藍警示燈",
    "kinio_floodlight.red_blue_duration_seconds": "紅藍燈時間",
    "kinio_floodlight.sensitivity": "亮燈觸發靈敏度",
    "kinio_floodlight.schedule": "生效時段",
    "on_off.on": "電源",
    "level_control.current_level": "亮度",
    "color_control.color_mode": "模式",
    "color_control.current_hue": "色相",
    "color_control.current_saturation": "飽和度",
    "color_control.color_temperature_mireds": "色溫",
    "color_control.color_temp_physical_min_mireds": "最冷色溫",
    "color_control.color_temp_physical_max_mireds": "最暖色溫",
    "identify.identify_time": "閃燈找到這台",
    "switch.number_of_positions": "段數",
    "switch.current_position": "目前段位",
    "switch.multi_press_max": "最多連按",
    "kinio_siren.alarm_enabled": "偵測到人時自動鳴響",
    "kinio_siren.sounding": "鳴響中",
    "kinio_siren.siren_type": "音效",
    "kinio_siren.siren_volume": "音量",
    "kinio_siren.siren_duration_seconds": "持續時間",
    "kinio_siren.schedule": "生效時段",
    "kinio_audio.speaker_volume": "喇叭音量",
    "kinio_audio.mic_volume": "麥克風音量",
    "kinio_audio.speaker_mute": "對講與提示音靜音（不影響警報）",
    "kinio_audio.clips": "語音片段",
    "kinio_doorbell.chime_type": "室內鈴類型",
    "kinio_doorbell.chime_time_seconds": "響鈴時長",
    "kinio_doorbell.ring_volume": "門鈴鈴聲音量",
    "kinio_doorbell.ring_tone": "門鈴鈴聲",
    "kinio_doorbell.auto_reply": "沒人接時",
    "kinio_doorbell.auto_reply_clip": "自動回覆的句子",
    "kinio_doorbell.auto_reply_after_seconds": "等多久",
    "kinio_call.enabled": "呼叫鍵",
    "kinio_call.ring_timeout_seconds": "響鈴時長",
    "kinio_call.state": "呼叫狀態",
    "kinio_ptz.object_tracking": "自動追蹤",
    "kinio_ptz.guard_enabled": "看守位",
    "kinio_ptz.guard_idle_seconds": "多久沒動就回去",
    "kinio_ptz.guard_preset": "看守的預置點",
    "kinio_ptz.patrol_enabled": "巡航",
    "kinio_ptz.patrol_dwell_seconds": "每個點停多久",
    "kinio_ptz.zoom": "變焦",
    "kinio_ptz.preset_epoch": "預置點世代",
    "kinio_ptz.zoom_ctrl": "變焦控制",
    "kinio_ptz.direction": "方向",
    "kinio_security.armed_mode": "警戒模式",
    "temperature_measurement.measured_value": "溫度",
    "boolean_state.state_value": "狀態",
    "illuminance_measurement.measured_value": "照度",
    "relative_humidity_measurement.measured_value": "濕度",
    "kinio_sensor_alert.temp_upper_limit": "溫度上限",
    "kinio_sensor_alert.temp_lower_limit": "溫度下限",
    "kinio_sensor_alert.humidity_upper_limit": "濕度上限",
    "kinio_sensor_alert.humidity_lower_limit": "濕度下限",
    "thermostat.local_temperature": "目前溫度",
    "thermostat.occupied_heating_setpoint": "目標溫度",
    "thermostat.occupied_cooling_setpoint": "冷氣目標溫度",
    "thermostat.system_mode": "模式",
    "thermostat.thermostat_running_state": "運轉狀態",
    "kinio_plug.power_level": "功率等級",
    "kinio_thermostat_ext.upper_setpoint": "溫度上限",
    "kinio_thermostat_ext.lower_setpoint": "溫度下限",
    "electrical_power_measurement.active_power": "目前功率",
    "electrical_power_measurement.voltage": "電壓",
    "electrical_power_measurement.active_current": "電流",
    "electrical_energy_measurement.cumulative_energy_imported": "累計用電",
    "kinio_halow.enabled": "HaLow",
    "kinio_halow.ssid": "網路名稱",
    "kinio_halow.channel": "頻道",
    "kinio_halow.bandwidth_mhz": "頻寬",
    "kinio_halow.country": "國碼",
    "kinio_halow.peers": "已配對攝影機",
    "kinio_halow.pairing": "配對中",
    "kinio_tv.volume": "音量",
    "kinio_tv.muted": "靜音",
    "kinio_tv.channel_number": "頻道",
    "media_input.current_input": "輸入來源",
    "media_playback.current_state": "播放狀態",
    "operational_state.operational_state": "運轉狀態",
    "operational_state.countdown_time": "剩餘時間",
    "laundry_washer_mode.current_mode": "洗衣模式",
    "dishwasher_mode.current_mode": "洗碗模式",
    "temperature_control.temperature_setpoint": "目標溫度",
    "temperature_control.min_temperature": "最低可設溫度",
    "temperature_control.max_temperature": "最高可設溫度",
    "refrigerator_and_temperature_controlled_cabinet_mode.current_mode": "冰箱模式",
    "refrigerator_alarm.state": "警報狀態",
    "fan_control.fan_mode": "風速",
    "fan_control.percent_setting": "風量",
    "fan_control.percent_current": "目前風量",
    "air_quality.air_quality": "空氣品質",
    "pm25_concentration_measurement.measured_value": "PM2.5",
    "hepa_filter_monitoring.condition": "濾網剩餘壽命",
    "rvc_operational_state.operational_state": "運轉狀態",
    "rvc_run_mode.current_mode": "運轉模式",
    "rvc_clean_mode.current_mode": "清潔模式",
    "kinio_system.fw_version": "韌體版本",
    "kinio_system.protocol_version": "協定版本",
    "kinio_system.device_status": "設備狀態旗標",
    "kinio_system.report_status": "回報狀態",
    "kinio_system.cmd_mechanism": "命令機制",
    "kinio_system.legacy_aid": "Legacy AID",
    "kinio_system.ota_url": "OTA 位址",
    "kinio_system.ai_platform_url": "AI 平台位址",
    "kinio_system.ai_platform_status": "AI 平台狀態",
    "kinio_system.echo": "Echo",
    "kinio_channel.width": "寬度",
    "kinio_channel.height": "高度",
    "kinio_channel.sub_bitrate": "次串流位元率",
    "kinio_channel.abilities": "支援功能",
    "kinio_onvif.profiles": "Profile",
    "kinio_power.wakeup_sources": "喚醒來源",
    "kinio_recording.playback_query": "回放查詢",
    "kinio_recording.event_months": "有錄影的月份",
    "kinio_recording.event_dates": "有錄影的日期",
    "kinio_recording.event_files": "錄影檔案",
    "kinio_storage.formatting": "格式化中",
    "kinio_streaming.video_channel_info": "串流通道",
    "kinio_streaming.snapshot": "快照",
    "kinio_video_signal.signal_format": "訊號格式",
    "kinio_journey.active_scene": "目前場景",
    "kinio_journey.scene_since": "場景開始",
    "kinio_journey.next_transition": "下一個切換",
    "kinio_journey.plan": "旅程設定",
    "kinio_journey.plan_version": "設定版本",
    "kinio_bed_presence.radar_enabled": "雷達",
    "kinio_bed_presence.in_bed": "在床",
    "kinio_bed_presence.present": "有人",
    "kinio_bed_presence.bed_zone": "床區",
    "kinio_bed_presence.away_timeout_seconds": "無人停機延時",
    "kinio_soundscape.playing": "播放中",
    "kinio_soundscape.sound_id": "音效",
    "kinio_soundscape.volume": "音量",
    "kinio_soundscape.fade_seconds": "淡入淡出（秒）",
    "kinio_soundscape.timer_minutes": "定時關閉",
    "kinio_soundscape.adaptive": "環境聲自適應",
    "kinio_soundscape.adaptive_max_volume": "自適應音量上限",
    "kinio_soundscape.library": "音效清單",
    "kinio_mic.attached": "麥克風",
    "kinio_mic.fault": "麥克風狀態",
    "kinio_mic.adaptive_enabled": "本次自適應",
    "kinio_sleep_session.upload_enabled": "數據收集",
    "kinio_sleep_session.recording": "記錄中",
    "kinio_sleep_session.edition": "版本",
    "kinio_sleep_session.session_id": "本晚紀錄",
    "kinio_sleep_session.last_upload": "最後上傳",
    "kinio_sleep_session.pending_minutes": "待上傳分鐘",
    "kinio_ir_remote.codeset_id": "空調碼組",
    "kinio_ir_remote.appliance": "家電類型",
    "kinio_ir_remote.ac_state": "空調狀態（推定）",
    "kinio_system.mac": "MAC",
    "kinio_system.p2p_id": "P2P ID",
    "kinio_system.agent_version": "Agent 版本",
    "kinio_system.vendor_device_type": "原廠型別碼",
    "kinio_system.operating_mode": "運作模式",
    "kinio_system.branding": "品牌資產",
    "kinio_local_services.rtsp_port": "RTSP 埠",
    "kinio_local_services.web_port": "網頁埠",
    "kinio_local_services.client_port": "Client 埠",
    "kinio_local_services.rtsp_user": "設備帳號",
    "kinio_local_services.rtsp_password": "設備密碼",
    "kinio_motion.pir_sleep_seconds": "PIR 休眠期",
    "kinio_motion.pir_level": "PIR 靈敏度（原廠值）",
    "kinio_object_recognition.person_sensitivity": "人形偵測靈敏度",
    "kinio_object_recognition.pet_enabled": "寵物偵測",
    "kinio_object_recognition.pet_sensitivity": "寵物偵測靈敏度",
    "kinio_recording.clip_min_seconds": "片段最短長度",
    "kinio_recording.clip_max_seconds": "片段最長長度",
    "kinio_ptz.pan_position": "水平位置",
    "kinio_ptz.tilt_position": "垂直位置",
    "kinio_image.scene": "拍攝環境",
    "kinio_image.scene_mode": "拍攝環境模式",
    "kinio_floodlight.intensity": "燈光強度",
    "kinio_doorbell.chime_volume": "室內鈴音量",
    "kinio_security.shield_status": "Shield 狀態",
    "kinio_channel.has_light": "有補光燈",
    "kinio_channel.has_siren": "有警報器",
    "kinio_channel.has_mic": "有麥克風",
    "kinio_channel.has_enforcer": "有紅藍警示燈"
  },
  "commands": {
    "kinio_debug.telnet": "telnet",
    "kinio_debug.log_control": "log 控制",
    "kinio_debug.tunnel_open": "開 tunnel",
    "kinio_debug.tunnel_close": "關 tunnel",
    "kinio_debug.diag": "遠端偵測",
    "kinio_debug.echo": "控制通道 echo",
    "kinio_debug.root_login": "開啟 root 登入",
    "kinio_debug.remote_shell": "遠端 shell 開關",
    "kinio_firmware.set_security_floor": "調高安全下限",
    "kinio_call.end": "結束呼叫",
    "kinio_journey.run_scene": "開始場景",
    "kinio_journey.stop_scene": "停止場景",
    "kinio_journey.preview": "預覽光效",
    "kinio_bed_presence.calibrate_bed_zone": "校正床區",
    "kinio_soundscape.play": "播放",
    "kinio_soundscape.stop": "停止",
    "kinio_soundscape.breathing_guide": "4-7-8 呼吸引導",
    "kinio_sleep_session.start_session": "開始記錄",
    "kinio_sleep_session.end_session": "結束記錄",
    "kinio_sleep_session.flush": "立即上傳",
    "kinio_ir_remote.ir_send": "送紅外鍵",
    "kinio_ir_remote.ac_set": "設定空調",
    "kinio_ir_remote.load_codeset": "載入碼組",
    "kinio_system.reboot": "重新啟動",
    "kinio_system.factory_reset": "原廠重置",
    "kinio_system.ota_start": "檢查韌體更新",
    "kinio_local_services.set_admin_credential": "設定管理密碼",
    "kinio_storage.format": "格式化",
    "kinio_storage.unmount": "安全移除記憶卡",
    "kinio_storage.smart_test": "硬碟健檢",
    "kinio_recording.manual_record_start": "開始手動錄影",
    "kinio_recording.manual_record_stop": "停止手動錄影",
    "kinio_siren.trigger": "觸發警報",
    "kinio_siren.stop": "停止警報",
    "kinio_ptz.stop": "停止",
    "kinio_ptz.calibrate": "校正",
    "kinio_ptz.set_preset": "儲存預設點",
    "kinio_ptz.goto_preset": "移至預設點",
    "kinio_ptz.clear_preset": "刪除預設點",
    "kinio_channel.test": "測試連線",
    "kinio_channel.reboot": "重新啟動攝影機",
    "kinio_channel.factory_reset": "攝影機原廠重置",
    "kinio_channel.upgrade": "升級攝影機韌體",
    "kinio_onvif.discover": "搜尋攝影機",
    "kinio_halow.pair_start": "開始配對",
    "kinio_halow.pair_stop": "停止配對",
    "kinio_halow.wake_peer": "喚醒攝影機",
    "kinio_station.poe_set": "PoE 孔供電",
    "kinio_node.site_wifi_set": "設定場域 Wi-Fi",
    "kinio_node.wifi_set": "設定使用者 Wi-Fi",
    "kinio_node.ttl_config": "設定 UART（TTL）",
    "kinio_node.ttl_open": "開啟 UART（TTL）橋接",
    "kinio_node.ttl_close": "關閉 UART（TTL）橋接",
    "kinio_node.caps": "查詢能力",
    "kinio_node.lan_peer": "區網配對對象",
    "kinio_ptz.move_relative": "移動",
    "kinio_ptz.jog": "點動",
    "kinio_ptz.move_absolute": "移至座標",
    "kinio_ptz.list_presets": "取得預設點",
    "kinio_floodlight.trigger": "點亮",
    "kinio_floodlight.stop": "熄滅",
    "kinio_floodlight.adjust_brightness": "調整亮度",
    "kinio_floodlight.adjust_color_temp": "調整色溫",
    "kinio_siren.custom_sound": "自訂音效",
    "kinio_siren.remove_custom_sound": "刪除自訂音效",
    "kinio_audio.adjust_speaker_volume": "調整音量",
    "kinio_audio.play_clip": "播放語音片段",
    "kinio_audio.upload_clip": "上傳語音片段",
    "kinio_audio.delete_clip": "刪除語音片段",
    "kinio_plug.adjust_power_level": "調整功率",
    "kinio_thermostat_ext.adjust_setpoint": "調整目標溫度",
    "kinio_power.enter_low_power": "進入低功耗",
    "kinio_power.wake": "喚醒",
    "kinio_system.reset_keep_wifi": "重設但保留 Wi-Fi",
    "kinio_system.net_mode_set": "切換網路模式",
    "kinio_system.renew_mqtt_queue": "重建訊息佇列",
    "kinio_system.ai_platform_stop": "停止 AI 平台",
    "kinio_system.credential_update": "更新設備憑證",
    "kinio_system.diag_readonly": "客服唯讀偵測",
    "kinio_recording.list_event_dates": "列出錄影日期",
    "kinio_recording.list_event_files": "列出錄影檔案",
    "kinio_streaming.start_rtsp": "開啟 RTSP",
    "kinio_streaming.stop_rtsp": "關閉 RTSP",
    "kinio_streaming.start_publish_rtsp": "開始推流",
    "kinio_streaming.stop_publish_rtsp": "停止推流",
    "media_playback.play": "播放",
    "media_playback.pause": "暫停",
    "media_playback.stop": "停止",
    "media_playback.previous": "上一個",
    "on_off.toggle": "切換",
    "media_playback.next": "下一個",
    "operational_state.start": "開始",
    "operational_state.pause": "暫停",
    "operational_state.resume": "繼續",
    "operational_state.stop": "停止",
    "rvc_operational_state.resume": "繼續清掃",
    "rvc_operational_state.pause": "暫停",
    "rvc_operational_state.go_home": "回充電座",
    "hepa_filter_monitoring.reset_condition": "重設濾網壽命"
  },
  "events": {
    "switch.initial_press": {
      "label": "按下"
    },
    "switch.long_press": {
      "label": "長按"
    },
    "switch.short_release": {
      "label": "短按"
    },
    "switch.long_release": {
      "label": "長按放開"
    },
    "switch.multi_press_complete": {
      "label": "連按"
    },
    "boolean_state.state_change": {
      "label": "開關狀態變化"
    },
    "occupancy_sensing.occupancy_changed": {
      "label": "有人 / 無人"
    },
    "kinio_system.connected": {
      "label": "重新連上"
    },
    "kinio_system.disconnected": {
      "label": "斷線"
    },
    "kinio_system.exception_report": {
      "label": "設備異常重開"
    },
    "kinio_system.connection_report": {
      "label": "連線報告",
      "feed_only": true
    },
    "kinio_system.unbound": {
      "label": "設備已移除"
    },
    "kinio_system.factory_reset_initiated": {
      "label": "設備已恢復原廠設定"
    },
    "kinio_system.booted": {
      "label": "設備開機",
      "labels": {
        "reason": {
          "power_on": "上電開機（斷電後重新通電）",
          "reset": "重置開機（設備自己重開）",
          "watchdog": "看門狗重開"
        }
      },
      "feed_only": true
    },
    "kinio_system.events_suppressed": {
      "label": "事件太多，暫時合併",
      "feed_only": true
    },
    "kinio_firmware.ota_started": {
      "label": "開始更新韌體"
    },
    "kinio_firmware.ota_succeeded": {
      "label": "韌體已更新"
    },
    "kinio_firmware.ota_failed": {
      "label": "韌體更新失敗"
    },
    "kinio_firmware.ota_progress": {
      "label": "韌體更新進度",
      "feed_only": true
    },
    "kinio_debug.root_login_changed": {
      "label": "root 登入開關變更",
      "feed_only": true
    },
    "kmgr_alert.opened": {
      "label": "KMS 事故"
    },
    "kmgr_alert.resolved": {
      "label": "KMS 事故已恢復"
    },
    "kmgr_alert.escalated": {
      "label": "KMS 事故已升級"
    },
    "kinio_credential.renewed": {
      "label": "設備憑證已更新"
    },
    "kinio_credential.rolled_back": {
      "label": "設備憑證更新失敗"
    },
    "kinio_credential.rejected": {
      "label": "設備憑證被拒"
    },
    "kinio_sensor_alert.temp_high": {
      "label": "溫度過高"
    },
    "kinio_sensor_alert.temp_low": {
      "label": "溫度過低"
    },
    "kinio_sensor_alert.humidity_high": {
      "label": "濕度過高"
    },
    "kinio_sensor_alert.humidity_low": {
      "label": "濕度過低"
    },
    "kinio_security.mode_changed": {
      "label": "警戒模式變更"
    },
    "kinio_security.home_deleted": {
      "label": "家戶已刪除"
    },
    "kinio_motion.motion": {
      "label": "偵測到移動"
    },
    "kinio_doorbell.press": {
      "label": "有人按門鈴"
    },
    "kinio_doorbell.missed": {
      "label": "門鈴未接"
    },
    "kinio_doorbell.auto_replied": {
      "label": "已自動回覆"
    },
    "kinio_call.request": {
      "label": "設備呼叫"
    },
    "kinio_object_recognition.object_detected": {
      "label": "偵測到物件",
      "labels": {
        "object_type": {
          "person": "偵測到人",
          "vehicle": "偵測到車輛",
          "pet": "偵測到動物",
          "package": "偵測到包裹"
        }
      }
    },
    "kinio_sound_detection.threshold_exceeded": {
      "label": "偵測到聲音"
    },
    "kinio_sound_recognition.sound_detected": {
      "label": "辨識到聲音",
      "labels": {
        "sound_class": {
          "smoke_alarm": "聽到煙霧警報聲",
          "co_alarm": "聽到一氧化碳警報聲",
          "glass_break": "聽到玻璃破裂",
          "dog": "聽到狗叫",
          "gunshot": "聽到疑似槍聲",
          "baby_cry": "聽到哭聲",
          "cat": "聽到貓叫",
          "scream": "聽到呼救聲",
          "other": "辨識到聲音"
        }
      }
    },
    "kinio_tamper.tampered": {
      "label": "鏡頭被遮擋"
    },
    "kinio_ai_compute.detection": {
      "label": "AI 偵測"
    },
    "kinio_subg.paired": {
      "label": "子設備已加入"
    },
    "kinio_subg.pair_failed": {
      "label": "子設備加入失敗"
    },
    "kinio_subg.left": {
      "label": "子設備已離開"
    },
    "kinio_analytics.line_crossed": {
      "label": "越線偵測",
      "alert_class": "motion"
    },
    "kinio_analytics.intrusion_detected": {
      "label": "區域入侵",
      "alert_class": "motion"
    },
    "kinio_analytics.object_left_or_taken": {
      "label": "物品遺留 / 移走",
      "labels": {
        "change": {
          "left": "有物品被遺留",
          "taken": "有物品被移走"
        }
      }
    },
    "kinio_analytics.crossing_counted": {
      "label": "人數統計"
    },
    "kinio_recording.started": {
      "label": "開始錄影",
      "feed_only": true
    },
    "kinio_recording.stopped": {
      "label": "停止錄影",
      "feed_only": true
    },
    "kinio_recording.interrupted": {
      "label": "錄影中斷"
    },
    "kinio_recording.segment_uploaded": {
      "label": "上傳錄影片段",
      "feed_only": true
    },
    "kinio_recording.segment_failed": {
      "label": "錄影片段上傳失敗",
      "feed_only": true
    },
    "kinio_recording.cloud_fault": {
      "label": "雲端錄影異常"
    },
    "kinio_recording.clip_ready": {
      "label": "錄影片段可播放"
    },
    "kinio_ptz.move": {
      "label": "雲台轉動",
      "feed_only": true
    },
    "kinio_ptz.tracking": {
      "label": "追蹤中"
    },
    "kinio_storage.inserted": {
      "label": "插入記憶卡"
    },
    "kinio_storage.removed": {
      "label": "取出記憶卡"
    },
    "kinio_storage.error": {
      "label": "記憶卡異常"
    },
    "kinio_plug.switched": {
      "label": "插座開關"
    },
    "kinio_plug.fault": {
      "label": "插座保護動作",
      "labels": {
        "kind": {
          "overload": "過載保護",
          "overvoltage": "電壓過高",
          "undervoltage": "電壓過低",
          "overcurrent": "電流過大"
        }
      }
    },
    "kinio_plug.energy_report": {
      "label": "用電回報",
      "feed_only": true
    },
    "kinio_plug.schedule_fired": {
      "label": "排程動作"
    },
    "kinio_provisioning.wifi_reconfig_succeeded": {
      "label": "已更換 Wi-Fi"
    },
    "kinio_provisioning.wifi_reconfig_failed": {
      "label": "更換 Wi-Fi 失敗"
    },
    "kinio_power.low_battery": {
      "label": "電量低"
    },
    "kinio_power.entering_sleep": {
      "label": "進入睡眠",
      "feed_only": true
    },
    "kinio_power.woke": {
      "label": "設備喚醒"
    },
    "kinio_video_signal.video_loss": {
      "label": "影像訊號中斷"
    },
    "kinio_mycam.moved": {
      "label": "攝影機被移動"
    },
    "kinio_mycam.power_unplugged": {
      "label": "攝影機沒插電"
    },
    "kinio_mycam.paused": {
      "label": "攝影機暫停"
    },
    "kinio_mycam.resumed": {
      "label": "攝影機繼續"
    }
  }
}
